import { WKBLoader } from "./wkb-loader.js";
import { VERSION } from "./lib/utils/version.js";
import { decodeHex } from "./lib/utils/hex-transcoder.js";
export const HexWKBLoader = {
  name: 'Hexadecimal WKB',
  id: 'wkb',
  module: 'wkt',
  version: VERSION,
  worker: true,
  category: 'geometry',
  extensions: ['wkb'],
  mimeTypes: [],
  options: WKBLoader.options,
  text: true,
  testText: isHexWKB,
  parse: async arrayBuffer => parseHexWKB(new TextDecoder().decode(arrayBuffer)),
  parseTextSync: parseHexWKB
};
function parseHexWKB(text, options) {
  var _WKBLoader$parseSync;
  const uint8Array = decodeHex(text);
  const binaryGeometry = (_WKBLoader$parseSync = WKBLoader.parseSync) === null || _WKBLoader$parseSync === void 0 ? void 0 : _WKBLoader$parseSync.call(WKBLoader, uint8Array.buffer, options);
  return binaryGeometry;
}
export function isHexWKB(string) {
  if (!string) {
    return false;
  }
  if (string.length < 10 || string.length % 2 !== 0) {
    return false;
  }
  if (!string.startsWith('00') && !string.startsWith('01')) {
    return false;
  }
  return /^[0-9a-fA-F]+$/.test(string.slice(2));
}
//# sourceMappingURL=hex-wkb-loader.js.map